import React from 'react';

import {SparklesIcon} from '@heroicons/react/outline';
import Card from './Card';
import Button, {ButtonSizes} from './ButtonNew';
import {ShortRightArrowIcon} from './svg';

const CoachPackageCard = ({
  name,
  description,
  onClick,
  buttonText = 'Book now',
  variant = 'default',
  avatars = [],
}) => {
  const handleButtonClick = (event) => {
    // Prevent the click event from reaching the Card
    event.stopPropagation();
    onClick();
  };

  return (
    <Card
      className={`relative flex flex-col overflow-hidden cursor-pointer hover:shadow-md transition duration-50 group ${
        variant === 'guided' ? 'border-indigo-200 bg-gradient-to-br from-indigo-50 via-white to-violet-50' : ''
      }`}
      onClick={onClick}
      border
    >
      {variant === 'guided' && (
        <>
          <div
            aria-hidden="true"
            className="pointer-events-none absolute inset-0 opacity-[0.35]"
            style={{
              backgroundImage:
                'radial-gradient(circle, rgb(99 102 241 / 0.18) 1px, transparent 1px)',
              backgroundSize: '14px 14px',
              maskImage:
                'radial-gradient(ellipse at top right, black 0%, transparent 70%)',
              WebkitMaskImage:
                'radial-gradient(ellipse at top right, black 0%, transparent 70%)',
            }}
          />
          <div
            aria-hidden="true"
            className="pointer-events-none absolute -top-16 -right-16 h-48 w-48 rounded-full bg-indigo-200/40 blur-3xl"
          />
          <div className="absolute right-4 top-4 inline-flex items-center gap-1 bg-indigo-100 text-indigo-700 text-xs font-medium rounded-lg px-2 py-1">
            <SparklesIcon className="w-3.5 h-3.5" strokeWidth={2} />
            Guided
          </div>
        </>
      )}
      <div className="relative flex flex-col justify-between w-full h-full">
        <div className="flex flex-col">
          <div className="flex">
            <h3 className={`text-xl font-bold ${variant === 'guided' ? 'pr-24' : ''}`}>
              {name}
            </h3>
          </div>
          <span className="my-2 mb-4 text-gray-500 font-medium">
            {description}
          </span>
          {variant === 'guided' && (
            <div className="flex items-center gap-3 mb-1">
              <div className="flex -space-x-2">
                {(avatars && avatars.length > 0 ? avatars : [null, null, null])
                  .slice(0, 3)
                  .map((src, i) => (src ? (
                    <img
                      // eslint-disable-next-line react/no-array-index-key
                      key={`${src}-${i}`}
                      src={`${src}?w=64`}
                      alt=""
                      className="w-8 h-8 rounded-full ring-2 ring-white object-cover bg-gray-100"
                      loading="lazy"
                    />
                  ) : (
                    <span
                      // eslint-disable-next-line react/no-array-index-key
                      key={`ph-${i}`}
                      className="w-8 h-8 rounded-full ring-2 ring-white bg-gradient-to-br from-indigo-200 to-violet-200"
                    />
                  )))}
              </div>
              <span className="text-xs font-medium text-gray-600 leading-tight">
                Matched from
                {' '}
                <span className="text-indigo-700 font-semibold">100+ expert coaches</span>
              </span>
            </div>
          )}
        </div>
        <Button
          size={ButtonSizes.LARGE}
          className="w-full mt-4 flex items-center justify-center"
          onClick={handleButtonClick}
        >
          {buttonText}
          <ShortRightArrowIcon stroke="#ffffff" className="w-3 ml-1.5" />
        </Button>
      </div>
    </Card>
  );
};

export default CoachPackageCard;

